import React from "react";
import Header from "../components/Header";
import AIChat from "../components/AIChat";

function Dashboard() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="container mx-auto max-w-5xl px-6 py-8">
        <AIChat />
      </main>
    </div>
  );
}

export default Dashboard;
